<template>
  <div class="mt-4">
    <img class="max-w-350px w-full mx-auto" src="@/assets/guides/permission-slides/find-help.webp" />
    <p class="w-3/4 mt-6 text-center text-gray-700 max-w-300px mx-auto">
      Tap the <span class="font-bold">“Help Circle”</span> at the top of the screen at any time to
      <span class="font-bold">learn more</span> about the current page you’re on!
    </p>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
